import { useEffect, useRef } from "react";
import { CALENDLY_URL } from "@/config/siteLinks";
import { loadCalendly } from "@/lib/calendly";

export const BookConsultation = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    loadCalendly()
      .then((Calendly) => {
        if (cancelled || !containerRef.current) return;
        containerRef.current.innerHTML = "";
        Calendly.initInlineWidget({
          url: CALENDLY_URL,
          parentElement: containerRef.current,
        });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section
      id="book"
      data-testid="book-consultation-section"
      className="py-24 sm:py-32 bg-[#F0EFEB] border-y border-[#1C1C1A]/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="max-w-3xl mb-12">
          <p className="label-eyebrow text-[#143628] mb-5">Book a consultation</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Pick a time that works for <em className="italic text-[#143628]">you.</em>
          </h2>
          <p className="text-[#4A4A48] mt-6 leading-relaxed text-lg max-w-2xl">
            Schedule your 1-1 technical and career alignment session. No redirects - book directly
            here in under a minute.
          </p>
        </div>

        <div
          data-testid="calendly-inline-widget"
          className="bg-white border border-[#1C1C1A]/10"
        >
          <div
            ref={containerRef}
            className="w-full min-w-[320px] h-[700px]"
            style={{ minHeight: "700px" }}
          />
        </div>
      </div>
    </section>
  );
};

export default BookConsultation;
